import { createPortal } from "react-dom";
import { X } from "lucide-react";

// iter132: portal-mounted at document.body so parent trees with
// `transform`, `filter`, `contain`, or `overflow` traps can't clip or
// hide the modal. Without the portal, a `position: fixed` child gets
// bound to the nearest containing block created by an ancestor with a
// transform — which is why the SEPA upload dialog sometimes only
// surfaced after a state change bumped it into a "clean" render tree
// (e.g. clicking Back on the member detail view).
export const Modal = ({ title, children, onClose }) => {
  if (typeof document === "undefined") return null;
  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999] animate-fadeIn">
      <div className="bg-white rounded-3xl p-6 w-full max-w-md animate-scaleIn max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full"><X className="w-5 h-5" /></button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
};
